'use client';

import React from 'react';
import Image from '../image';

import { cn } from '@fshr/shared-react';
import tree from './tree.svg';
import ppTree from './pp-tree.svg';

interface LoadingIndicatorProps {
	title?: string;
	className?: string;
	ppMode?: boolean;
}

const LoadingIndicator = React.forwardRef(
	(
		{ title, className, ppMode }: LoadingIndicatorProps,
		ref: React.ForwardedRef<HTMLDivElement>
	) => {
		return (
			<div
				className={cn(
					'fixed inset-0 flex items-center justify-center bg-white z-49 transition-opacity duration-300 select-none',
					className
				)}
				ref={ref}
			>
				<div className="relative">
					<Image
						className={cn('my-[40px]', {
							'w-[160px]': !ppMode,
							'h-[80px]': !ppMode,
							'w-[180px]': ppMode,
							'h-[82px]': ppMode,
						})}
						roughSize="s"
						height={ppMode ? 82 : 80}
						width={ppMode ? 180 : 160}
						src={ppMode ? ppTree : tree}
						alt="loading indicator"
						aria-hidden="true"
						staticImage={true}
					/>
					{['-0.15', '-0.1s', '-0.05s'].map(animationDelay => (
						<div
							key={animationDelay}
							className={cn(
								'absolute top-0 border border-transparent border-l-0 border-r-0 rounded-full animate-loading-indicator-spin border-t-black',
								{
									'w-[160px]': !ppMode,
									'h-[160px]': !ppMode,
									'w-[180px]': ppMode,
									'h-[180px]': ppMode,
								}
							)}
							style={{ animationDelay }}
						/>
					))}
				</div>
			</div>
		);
	}
);

LoadingIndicator.displayName = 'LoadingIndicator';

export default LoadingIndicator;
